import { IPermissionSettingParams, PermissionSettingPageType } from '@umu/umu-api';
export { PlatePermissionType } from '@umu/umu-types';
import { ISearchItem } from '../../searchInput/index';
import { PERMISSION_CONTENT_TYPE } from '../components/permissionContentInfo/interface';
import { IAccountInfo } from './account';
import { Account } from '../../../@utils/normalizeAccount';

enum PermissionType {
    __INIT__ = '__INIT__',
    NONE_ALL = '0',
    PUBLIC_ALL = '1',
    PUBLIC_IN_THE_COMPANY = '2',
    DESIGNATED_ACCOUNT = '3',
    USE_PLATE = '4',
}
interface IPermissionSettingInfo {
    id: string;
}
interface IContentLinkInfo {
    title?: JSX.Element | string;
    tips?: JSX.Element | string | string[] | JSX.Element[];
    content?: JSX.Element | string;
    prefixElement?: React.ReactNode | string; // 前置元素
    suffixElement?: React.ReactNode | string; // 后置元素
}
interface IPermissionOption {
    label: string;
    value: string;
}

interface IPermissionSettingProps extends React.HTMLAttributes<HTMLDivElement> {
    title: string;
    subTitle?: string;
    prefixCls?: string; // 样式前缀
    platformPermission?: PlatePermissionType; // 平台权限
    prefixElement?: React.ReactNode | string; // 前置元素
    suffixElement?: React.ReactNode | string; // 后置元素
    isHideContentLink?: boolean; // 是否隐藏关联内容信息
    isHideFooter?: boolean; // 是否隐藏底部
    params: IPermissionSettingParams;
    okProps?: any; // 确定按钮属性
    okText?: string; // 确定按钮文案
    cancelText?: string; // 取消按钮文案
    contentLinkInfo?: IContentLinkInfo;
    normalizeAccountEPU?: (account: Account) => string;
    normalizeAccountName?: (account: Account) => string;
    pageType?: PermissionSettingPageType; // 页面类型
    isCloseInitLoading?: boolean; // 是否关闭初始化加载数据
    onLoadPermissionSetting?: (
        pageType?: PermissionSettingPageType,
        params?: IPermissionSettingParams,
    ) => Promise<IPermissionSettingInfo>; // 加载导航回调
    onClose?(): void; // 关闭弹窗回调
    onUpdate?: (data: IPermissionSettingInfo) => void; // 更新页面信息回调函数
    onSave?: (data: IPermissionSettingInfo, params?: IPermissionSettingParams) => Promise<{ isSuccess: boolean }>; // 保存按钮回调函数
    onSuccess?: (data?: {
        isSuccess: boolean;
        params?: IPermissionSettingParams;
        info?: IPermissionSettingDataInfo;
    }) => void; // 配置成功回调函数
    onSearchMember?: (key: string) => Promise<ISearchItem[]>;
}
interface INavInfo {
    access_permission: PermissionType;
    child_nav: INavInfo[];
    create_ts: string;
    delete_status: string;
    enterprise_id: string;
    id: string;
    is_favorite: 0 | 1;
    root_id: string;
    is_open: 0 | 1;
    old_is_open: 0 | 1;
    is_publish: 0 | 1;
    level: string;
    name: string;
    nav_color: string;
    parent_id: string;
    path: string;
    root_access_permission: PermissionType;
    related_content_access_permission: PermissionType;
    related_content_id: string;
    related_type: PERMISSION_CONTENT_TYPE;
    se_id: string;
    show_index: string;
    update_ts: string;
}
interface IPermissionSettingDataInfo {
    permissionList: IPermissionOption[];
    permissionValue: PermissionType;
    isLoading: boolean;
    navInfo: INavInfo;
}
interface IClosePermissionInfo {
    list: IAccountInfo[];
    isAll: boolean;
}
export {
    PermissionType,
    INavInfo,
    IClosePermissionInfo,
    IPermissionSettingDataInfo,
    IContentLinkInfo,
    IPermissionSettingInfo,
    IPermissionSettingProps,
};
